import PropTypes from 'prop-types';
import { Sparkles } from 'lucide-react';
import { fmtCurrency } from '@/utils/money';
import { milesGold } from './milesCardStyles';

/**
 * The Defera Miles the customer applied, as a line in Review's price (like a
 * discount code), in the Miles card's gold. Quotes what the total really fell
 * by.
 */
export default function MilesAppliedLine({ miles, appliedCents }) {
  return (
    <div
      className="relative overflow-hidden rounded-2xl border border-[#f2d9a0]/20 bg-gradient-to-r from-[#f2d9a0]/[0.09] via-[#f2d9a0]/[0.03] to-transparent px-4 py-3 mb-6"
      data-testid="miles-applied-line"
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center ${milesGold.coin}`}>
            <Sparkles className={`w-4 h-4 ${milesGold.coinIcon}`} aria-hidden="true" />
          </div>
          <div className="min-w-0">
            <div className="text-white font-normal text-sm">Defera Miles applied</div>
            <div className="text-[#f3dca6]/70 text-xs font-normal tabular-nums">{miles.toLocaleString()} Miles</div>
          </div>
        </div>
        <div className="text-[#f6e3b4] font-semibold text-lg tabular-nums whitespace-nowrap">
          -${fmtCurrency(appliedCents)}
        </div>
      </div>
    </div>
  );
}

MilesAppliedLine.propTypes = {
  /** The Miles spent on this checkout. */
  miles: PropTypes.number.isRequired,
  /** What the total really fell by, in cents. */
  appliedCents: PropTypes.number.isRequired,
};
